import { Selector } from 'model/State';

export const selectUUID: Selector<string | null> = (state) =>
  state.cart.payload.ifSuccess((cart) => cart && cart.uuid) || null;

export default selectUUID;
